import { AppImageTreatment } from "../AppImageTreatment";

const NotificationDetailImage = ({
  imageUrl,
  xBox,
  yBox,
  wBox,
  hBox,
  detectedObjects,
  materialToDisplay = [],
  compact = false,
}) => {
  if (!imageUrl) {
    return null;
  }

  return (
    <div className="notification-detail-preview-card">
      <AppImageTreatment
        imageUrl={imageUrl}
        xBox={xBox}
        yBox={yBox}
        wBox={wBox}
        hBox={hBox}
        detectedObjects={detectedObjects}
        materialToDisplay={materialToDisplay}
        compact={compact}
        fitCrop
      />
    </div>
  );
};

export default NotificationDetailImage;
